import React from 'react';
import { Link } from 'react-router-dom'

export default function CategoryBox({ salon }) {
    return (
        <Link to={`/doctor/${salon.categoryName.toLowerCase().replaceAll(" ", "_").replace("&", "and")}`} className='categ-box'>
            <img src={`${salon.categImageUrl}`} alt={salon.categoryName} />
            <h4>
                {salon.categoryName}
            </h4>
        </Link>
    )
}
